import ProductSearchTable from './ProductSearchTable';
export default ProductSearchTable;
